import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

export const getEventsByRestaurant = async (restaurantId) => {
  try {
    const response = await axios.get(`${BASE_API}/events/restaurant/${restaurantId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    return { events: [], restaurantId, restaurantName: "" };
  }
};

export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${BASE_API}/events`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all events:", error);
    return { events: [] };
  }
};
